'use strict';
import { Injectable} from 'ng-metadata/core';

const MOBILE = "Mobile"
const DESKTOP = 'Desktop';

@Injectable()
export class WindowInfoUtils {

	public getBrowserType(){
        let test = function(regexp) {
            return regexp.test(window.navigator.userAgent)
        }
        switch (true) {
            case test(/edg/i): return "Microsoft Edge";
            case test(/trident/i): return "Microsoft Internet Explorer";
            case test(/firefox|fxios/i): return "Mozilla Firefox";
            case test(/opr\//i): return "Opera";
            case test(/ucbrowser/i): return "UC Browser";
            case test(/samsungbrowser/i): return "Samsung Browser";
            case test(/chrome|chromium|crios/i): return "Google Chrome";
            case test(/safari/i): return "Apple Safari";
            default: return "Other";
        }
    }

    public getDeviceType(){
        return this.isMobile() ? MOBILE : DESKTOP;
    }

    public isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

}




// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/windowInfoUtils.service.ts